import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGridNineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "GridNine",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.8125 2.625H2.1875C1.95544 2.625 1.73288 2.71719 1.56878 2.88128C1.40469 3.04538 1.3125 3.26794 1.3125 3.5V10.5C1.3125 10.7321 1.40469 10.9546 1.56878 11.1187C1.73288 11.2828 1.95544 11.375 2.1875 11.375H11.8125C12.0446 11.375 12.2671 11.2828 12.4312 11.1187C12.5953 10.9546 12.6875 10.7321 12.6875 10.5V3.5C12.6875 3.26794 12.5953 3.04538 12.4312 2.88128C12.2671 2.71719 12.0446 2.625 11.8125 2.625ZM5.6875 7.875V6.125H8.3125V7.875H5.6875ZM8.3125 8.75V10.5H5.6875V8.75H8.3125ZM2.1875 6.125H4.8125V7.875H2.1875V6.125ZM5.6875 5.25V3.5H8.3125V5.25H5.6875ZM9.1875 6.125H11.8125V7.875H9.1875V6.125ZM11.8125 5.25H9.1875V3.5H11.8125V5.25ZM4.8125 3.5V5.25H2.1875V3.5H4.8125ZM2.1875 8.75H4.8125V10.5H2.1875V8.75ZM11.8125 10.5H9.1875V8.75H11.8125V10.5Z",
			fill: "currentColor"
		})
	})
});
export default SvgGridNineIcon;
